import React from 'react';
import { theme } from '../../../../db.json';
import { ContainerMenu, ContainerMenuButtons } from '../../../../components/Containers';
import ButtonMainContainer from '../../../../components/Home/MainContainer/ButtonMainContainer';

export default function TemplateControladoria() {
  const themeColors = theme.colors.systems;
  return (
    <ContainerMenu>
      <ContainerMenuButtons>
        <ButtonMainContainer
          type="button"
          color={themeColors.NS.Controladoria}
          name="Orçamento Anual"
          link="/novo-sistema/controladoria/orcamento-anual"
          linkImg="/images/icons/buttons/diamond.svg"
        />

        <ButtonMainContainer
          type="button"
          color={themeColors.NS.Controladoria}
          name="Estrutura Orçamentária"
          link="/novo-sistema/controladoria/estrutura-orcamentaria"
          linkImg="/images/icons/buttons/keys.svg"
        />

        <ButtonMainContainer
          type="button"
          color={themeColors.NS.Controladoria}
          name="Gestão Financeira"
          link="/novo-sistema/controladoria/gestao-financeira"
          linkImg="/images/icons/buttons/court.svg"
        />

        <ButtonMainContainer
          type="button"
          color={themeColors.NS.Controladoria}
          name="Gestão de Alçadas"
          link="/novo-sistema/controladoria/gestao-alcadas"
          linkImg="/images/icons/buttons/key.svg"
        />

        <ButtonMainContainer
          type="button"
          color={themeColors.NS.Controladoria}
          name="Billing"
          link="/novo-sistema/controladoria/billing"
          linkImg="/images/icons/buttons/tag2.svg"
        />

        <ButtonMainContainer
          type="button"
          color={themeColors.NS.Controladoria}
          name="Dashboard"
          link="/novo-sistema/controladoria/dashboard"
          linkImg="/images/icons/buttons/speedometer.svg"
        />
      </ContainerMenuButtons>
    </ContainerMenu>
  );
}
